import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";

const EMPTY = { label: "", bank_name: "", account_number: "", ifsc: "", active: true };

export function RkfBankAccountsTab({ canEdit }) {
  const [rows, setRows] = useState([]);
  const [f, setF] = useState(EMPTY);
  const load = () => api.get("/masters/rkf-bank-accounts").then(r => setRows(r.data || [])).catch(() => setRows([]));
  useEffect(() => { load(); }, []);
  const add = async (e) => {
    e.preventDefault();
    try { await api.post("/masters/rkf-bank-accounts", f); toast.success("Account added"); setF(EMPTY); load(); }
    catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
  };
  const toggle = async (b) => {
    try { await api.put(`/masters/rkf-bank-accounts/${b.id}`, { label: b.label, bank_name: b.bank_name, account_number: b.account_full || "", ifsc: b.ifsc, active: !b.active }); load(); }
    catch (err) { toast.error(err.response?.data?.detail || "Failed"); }
  };
  return (
    <div className="space-y-4" data-testid="rkf-banks-tab">
      <p className="text-sm text-slate-500">RKF's own bank accounts. Accounts picks one as "Paid from" when disbursing an advance or posting a payment.</p>
      {canEdit && (
        <Card><CardContent className="p-4">
          <form onSubmit={add} className="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
            <div><Label>Label *</Label><Input value={f.label} onChange={e => setF({ ...f, label: e.target.value })} placeholder="e.g. Main FCRA" data-testid="rkf-bank-label" /></div>
            <div><Label>Bank *</Label><Input value={f.bank_name} onChange={e => setF({ ...f, bank_name: e.target.value })} data-testid="rkf-bank-name" /></div>
            <div><Label>Account no. *</Label><Input value={f.account_number} onChange={e => setF({ ...f, account_number: e.target.value })} data-testid="rkf-bank-acc" /></div>
            <div><Label>IFSC</Label><Input value={f.ifsc} onChange={e => setF({ ...f, ifsc: e.target.value.toUpperCase() })} data-testid="rkf-bank-ifsc" /></div>
            <Button type="submit" data-testid="rkf-bank-add">Add account</Button>
          </form>
        </CardContent></Card>
      )}
      <Card><CardContent className="p-0">
        <table className="w-full text-sm">
          <thead className="text-xs uppercase text-slate-500 bg-slate-50"><tr className="border-b">
            <th className="text-left px-3 py-2">Label</th><th className="text-left px-3 py-2">Bank</th><th className="text-left px-3 py-2">Account</th>
            <th className="text-left px-3 py-2">IFSC</th><th className="text-left px-3 py-2">Active</th>
          </tr></thead>
          <tbody>
            {!rows.length && <tr><td colSpan={5} className="text-center text-slate-500 py-6" data-testid="rkf-banks-empty">No RKF bank accounts yet.</td></tr>}
            {rows.map(b => (
              <tr key={b.id} className="border-b border-slate-100" data-testid={`rkf-bank-${b.id}`}>
                <td className="px-3 py-2 font-medium">{b.label}</td><td className="px-3 py-2">{b.bank_name}</td>
                <td className="px-3 py-2 font-mono">{b.account_masked}</td><td className="px-3 py-2 font-mono">{b.ifsc}</td>
                <td className="px-3 py-2"><Switch checked={b.active} disabled={!canEdit} onCheckedChange={() => toggle(b)} data-testid={`rkf-bank-active-${b.id}`} /></td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardContent></Card>
    </div>
  );
}
